import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className='not-found'>
      <h1>404 Page Not Found</h1>
      <p>The page you requested does not exist.</p>
      <Link to='/products/'>
        <button className='explore-categories'>Continue shopping</button>
      </Link>
    </div>
  );
};

export default NotFound;
